import React, { useEffect, Ref, forwardRef, debounce } from "react";
import Home from "../Home";
import { useState } from "react";
import axios from "axios";
import Markettrade from "../markettrade/Markettrade";
import { baseUrl } from "../constant.js";
import { useNavigate } from "react-router-dom";
import { liveRateUrl } from "../constant.js";
import { Link } from "react-router-dom";
const Mcxlist = ({
  mcx,
  live,
  title,
  exparydate,
  lotsize,
  categotyid,
  checked1,
  high,
  low,
  ltp,
  buy,

  sell,
  token,
}) => {
  const [price, setPrice] = useState(0);
  const [previousPrice, setPreviousPrice] = useState(0);
  const [colour, setcolour] = useState("");

  // const [buy, setbuy] = useState(0);
  // const [sell, setsell] = useState(0);
  // const [ltp, setltp] = useState(0);
  // const [high, sethigh] = useState(0);
  // const [low, setlow] = useState(0);
  // const [title, settitle] = useState(0);
  // const [exparydate, setexparydate] = useState(0);
  // const [lotsize, setlotsize] = useState(0);
  // const [keyvalue, setkeyvalue] = useState(0);
  // const [categotyid, setcategotyid] = useState(0);
  // const [checked1, setchecked1] = useState(0);
  // const [token, settoken] = useState(0);
  // const [searchTerm, setsearchTerm] = useState(0);
  const [isChecked, setIsChecked] = useState(checked1);
  // console.log(mcx);
  // useEffect(
  //   () => {
  //     mcx.map((item1) => {
  //       const matchingItem = live.find(
  //         (item2) => item2.InstrumentIdentifier == item1.instrument_token
  //       );
  //       //   setbuy = matchingItem?.BuyPrice;
  //       //   setsell = matchingItem?.SellPrice;
  //       //   setltp = matchingItem?.LastTradePrice;
  //       //   sethigh = matchingItem?.High;
  //       //   setlow = matchingItem?.Low;
  //       //   settitle = item1.title;
  //       //   setexparydate = item1.expire_date;
  //       //   setlotsize = item1.QuotationLot;
  //       //   setkeyvalue = item1.category_id;
  //       //   setcategotyid = item1.category_id;
  //       //   setchecked1 = item1.is_checked;
  //       //   settoken = item1.instrument_token;
  //       //   setsearchTerm = searchTerm;
  //       // });
  //       if (matchingItem) {
  //         setbuy(matchingItem.BuyPrice);
  //         setsell(matchingItem.SellPrice);
  //         setltp(matchingItem.LastTradePrice);
  //         sethigh(matchingItem.High);
  //         setlow(matchingItem.Low);
  //       }

  //       settitle(item1.title);
  //       setexparydate(item1.expire_date);
  //       setlotsize(item1.QuotationLot);
  //       setkeyvalue(item1.category_id);
  //       setcategotyid(item1.category_id);
  //       setchecked1(item1.is_checked);
  //       settoken(item1.instrument_token);
  //     });
  //   },
  //   mcx,
  //   live
  // );

  const getBuyColor = () => {
    const previousBuyPrice = localStorage.getItem(token + "-Buy-Price");

    if (previousBuyPrice > buy) {
      localStorage.setItem(token + "-Buy-Price", buy);
      console.log(previousBuyPrice, buy, token, "red");
      return { backgroundColor: "red" };
    } else if (previousBuyPrice < buy) {
      console.log(previousBuyPrice, buy, token, "green");
      localStorage.setItem(token + "-Buy-Price", buy);
      return { backgroundColor: "green" };
    } else if (previousBuyPrice === buy) {
      localStorage.setItem(token + "-Buy-Price", buy);
      const themelight = localStorage.getItem("background");
      if (themelight == 0) {
        return { backgroundColor: "#1e293b" };
      } else if (themelight == 1) {
        return { backgroundColor: "#edf9fe" };
      } else if (themelight == 2) {
        return { backgroundColor: "#1e5655" };
      }
    }
  };
  const getSellColor = () => {
    const previousSellPrice = localStorage.getItem(token + "-Sell-Price");

    if (previousSellPrice > sell) {
      localStorage.setItem(token + "-Sell-Price", sell);
      return { backgroundColor: "red" };
    } else if (previousSellPrice < sell) {
      localStorage.setItem(token + "-Sell-Price", sell);
      return { backgroundColor: "green" };
    } else {
      localStorage.setItem(token + "-Buy-Price", buy);
      const themelight = localStorage.getItem("background");
      if (themelight == 0) {
        return { backgroundColor: "#1e293b" };
      } else if (themelight == 1) {
        return { backgroundColor: "#edf9fe" };
      } else if (themelight == 2) {
        return { backgroundColor: "#1e5655" };
      }
    }
  };
  const mcxwatch = async () => {
    var isChkChecked = 0;
    if (isChecked === 0) {
      var isChkChecked = 1;
    }
    setIsChecked(isChecked ? 0 : 1);
    const id = localStorage.getItem("users");
    const token = localStorage.getItem("token");
    const categoryid = categotyid;
    const formdata = new FormData();
    formdata.append("ischecked", isChkChecked);
    formdata.append("Token", token);
    formdata.append("category_id", categoryid);
    const mcxwatchlist = await axios.post(
      baseUrl + "authController/addUserWatchList",
      formdata,
    );
  };
  useEffect(() => {}, [price]);
  const getPriceChangeColor = () => {
    if (price > previousPrice) {
      return "green";
    } else if (price < previousPrice) {
      return "red";
    } else {
      return "black";
    }
  };
  const navigate = useNavigate();

  const onbuttonclick = async () => {
    const token1 = token;
    const tokenheader = localStorage.getItem("token");
    const formdata = new FormData();
    formdata.append("Token", tokenheader);
    formdata.append("catToken", token1);
    const rate = await axios.post(liveRateUrl, formdata);
    const fathdata = await rate.data.livedata[0];

    navigate("/markettrade", {
      state: {
        name: title,
        token: token1,
        catid: categotyid,
        exparydate: exparydate,
      },
    });
  };
  return (
    <>
      {/* <div className="tablecard">
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Name</th>
              <th>Expiry Date</th>
              <th>Lot Size</th>
              <th>Sell</th>
              <th>Buy</th>
              <th>Ltp</th>
            </tr>
          </thead>
          {mcx.map((item1) => {
            const matchingItem = Array.isArray(live)
              ? live.find(
                  (item2) =>
                    item2.InstrumentIdentifier == item1.instrument_token
                )
              : (<>
                  <h1>null data</h1>
                </>)(
                  <tbody>
                    <tr>
                      <td></td>
                      <td>dfgfdgdf</td>
                      <td>dfgdfgd</td>
                      <td>dgdfgdg</td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                );
          })}
        </table>
      </div> */}
      <div className="tab_search_body" key={1}>
        <div className="futures_List">
          <div className="futures_list_text">
            <Link
              to=""
              onClick={() => {
                {
                  onbuttonclick();
                }
              }}
            >
              <h3>{title}</h3>
              <h5>{exparydate}</h5>
              <h6 style={{ marginTop: "px" }}>Lot Size: {lotsize}</h6>
            </Link>
          </div>
          <div className="futures_lot_size">
            <h4 style={getBuyColor()}>{buy}</h4>
            <h5>High: {high}</h5>
          </div>

          <div className="futures_lot_size">
            <h4 style={getSellColor()}>{sell}</h4>
            <h5>Low {low}</h5>
          </div>
          <div className="futures_Check">
            <input
              type="checkbox"
              value=""
              id="check1"
              className="form-check-input"
              checked={isChecked}
              onChange={() => {
                mcxwatch();
              }}
            />{" "}
            <h5 style={{ marginTop: "9px" }}>Ltp {ltp}</h5>{" "}
          </div>
        </div>
      </div>
    </>
  );
};
export default Mcxlist;
